import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class PaymentsService {

  constructor(
    private http: HttpClient
  ) { }

  getTransactions(queryParam:any) {
    const params = new HttpParams({fromObject: queryParam});
    return this.http.get(urls.API_URL + urls.TRANSATIONS, {params})
      .pipe(catchError(errorHandl));
  }
  getTransactionById(id:any) {
    return this.http.get(urls.API_URL + urls.TRANSATIONS +`/${id}`)
      .pipe(catchError(errorHandl));
  }
  getPaymentMethods(queryParam:any) {
    const params = new HttpParams({fromObject: queryParam});
    return this.http.get(urls.API_URL + urls.PAYMENT_METHODS, {params})
      .pipe(catchError(errorHandl));
  }


  search(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http
      .get(urls.API_URL + urls.PAYMENT_METHODS, { params })
      .pipe(catchError(errorHandl));
  }

  generatePaymentLink(tripId: any) {
    return this.http
      .post(urls.API_URL + urls.CHARGE_PAYMENT + `/${tripId}/link`, {})
      .pipe(catchError(errorHandl));
  }

  chargePayment(tripId: any) {
    return this.http
      .post(urls.API_URL + urls.CHARGE_PAYMENT + `/${tripId}/charge`, {})
      .pipe(catchError(errorHandl));
  }
  refundPayment(tripId:any, payload:any){
     return this.http
      .post(urls.API_URL + urls.PAYMENTS +`/trips/${tripId}/refund`, payload)
      .pipe(catchError(errorHandl));
  }

  verify(tripId: any) {
    return this.http
      .post(urls.API_URL + urls.PAYMENTS + `/trips/${tripId}/verify`, {})
      .pipe(catchError(errorHandl));
  }
}
